// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-window {
    width: 100%;
    padding: 160px 7vw 0 15vw;
    display: flex;
    justify-content: center;
    align-items: center;
}

.project-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 100%;
}

.project-wrapper.odd {
    flex-direction: row-reverse;
}

.project-title {
    margin-bottom: 15px;
    font-size: 36px;
    font-weight: 500;
    color: #fff;
}

.about-project .desc {
    font-size: 18px;
    font-weight: 400;
}

.project-img {
    margin-left: 100px;
    object-fit: contain;
    animation: jump 2.7s infinite;
    position: relative;
    top: 0px;
    filter: drop-shadow(2px 10px 20px rgba(255, 255, 255, 0.32));
}

.odd .project-img {
    margin-right: 100px;
    margin-left: 0;
}

@keyframes jump {
    0% {
        top: 20px;
    }

    50% {
        top: -20px;
    }

    100% {
        top: 20px;
    }
}

.project-img  img {
    border-radius: 18px;
    max-width: 500px;
    width: fit-content;
    height: auto;
}

@media screen and (max-width: 1150px) {
    .project-window {
        padding-left: 17vw;
        padding-top: 180px;
    }

    .project-img {
        margin-left: 60px;
    }

    .odd .project-img {
        margin-right: 60px;
    }

    .project-img  img  {
        max-width: 400px;
    }
}

@media screen and (max-width: 950px), screen and (max-height: 550px) {
    .project-wrapper, .project-wrapper.odd {
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
    }
    .project-window {
        padding-left: 25vw;
        padding-top: 100px;
    }

    .project-title {
        margin-top: 40px;
    }

    .project-img {
        margin: 0;
    }

    .odd .project-img {
        margin: 0;
    }

    .project-img  img  {
        max-width: 450px;
    }
}

@media screen and (max-width: 750px) {
    .project-window {
        padding: 110px 150px 0;
    }
    .project-wrapper, .project-wrapper.odd {
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
    }

    .project-title {
        margin-top: 35px;
        font-size: 32px;
    }

    .about-project .desc {
        font-size: 16px;
    }

    .about-project .btn {
        font-size: 16px;
    }

    .project-img {
        margin: 0;
    }
    .odd .project-img {
        margin: 0;
    }

    .project-img  img  {
        max-width: 300px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ProjectCardStyle.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,QAAQ;IACR,4DAA4D;AAChE;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,8BAA8B;QAC9B,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".project-window {\n    width: 100%;\n    padding: 160px 7vw 0 15vw;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.project-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    height: 100%;\n}\n\n.project-wrapper.odd {\n    flex-direction: row-reverse;\n}\n\n.project-title {\n    margin-bottom: 15px;\n    font-size: 36px;\n    font-weight: 500;\n    color: #fff;\n}\n\n.about-project .desc {\n    font-size: 18px;\n    font-weight: 400;\n}\n\n.project-img {\n    margin-left: 100px;\n    object-fit: contain;\n    animation: jump 2.7s infinite;\n    position: relative;\n    top: 0px;\n    filter: drop-shadow(2px 10px 20px rgba(255, 255, 255, 0.32));\n}\n\n.odd .project-img {\n    margin-right: 100px;\n    margin-left: 0;\n}\n\n@keyframes jump {\n    0% {\n        top: 20px;\n    }\n\n    50% {\n        top: -20px;\n    }\n\n    100% {\n        top: 20px;\n    }\n}\n\n.project-img  img {\n    border-radius: 18px;\n    max-width: 500px;\n    width: fit-content;\n    height: auto;\n}\n\n@media screen and (max-width: 1150px) {\n    .project-window {\n        padding-left: 17vw;\n        padding-top: 180px;\n    }\n\n    .project-img {\n        margin-left: 60px;\n    }\n\n    .odd .project-img {\n        margin-right: 60px;\n    }\n\n    .project-img  img  {\n        max-width: 400px;\n    }\n}\n\n@media screen and (max-width: 950px), screen and (max-height: 550px) {\n    .project-wrapper, .project-wrapper.odd {\n        flex-direction: column-reverse;\n        justify-content: center;\n        align-items: center;\n    }\n    .project-window {\n        padding-left: 25vw;\n        padding-top: 100px;\n    }\n\n    .project-title {\n        margin-top: 40px;\n    }\n\n    .project-img {\n        margin: 0;\n    }\n\n    .odd .project-img {\n        margin: 0;\n    }\n\n    .project-img  img  {\n        max-width: 450px;\n    }\n}\n\n@media screen and (max-width: 750px) {\n    .project-window {\n        padding: 110px 150px 0;\n    }\n    .project-wrapper, .project-wrapper.odd {\n        flex-direction: column-reverse;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .project-title {\n        margin-top: 35px;\n        font-size: 32px;\n    }\n\n    .about-project .desc {\n        font-size: 16px;\n    }\n\n    .about-project .btn {\n        font-size: 16px;\n    }\n\n    .project-img {\n        margin: 0;\n    }\n    .odd .project-img {\n        margin: 0;\n    }\n\n    .project-img  img  {\n        max-width: 300px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
